/* Perfect Sense PDP — cloned from mn-pdp.js. Safe to edit: nothing else uses it. */
/* Melanie Newman — PT-pattern native PDP engine + live cart AJAX. Draft 160725. */
(function () {
  var root = document.querySelector('.ps-pdp');
  if (!root) return;
  var dataEl = document.getElementById('ps-pdp-data');
  if (!dataEl) return;
  var DATA = JSON.parse(dataEl.textContent);
  // preview aid: ?mnws=1 simulates a wholesale-tagged login (display only)
  if (/[?&]mnws=1/.test(location.search)) DATA.isWholesale = true;
  var sellyWS = false; // set true once SELLY wholesale prices are applied
  // legacy fixed Value Packs are being retired — never offer them as add-ons
  DATA.addons = (DATA.addons || []).filter(function (p) { return !/value\s*pack|duo\s*pack|works\s*pack/i.test(p.title || ''); });
  var isTools = DATA.mode === 'tools';
  // Tool ladder is DOLLAR-based (Melanie, 5 Aug 2026): $5 off the 2nd tool, $10 off
  // the 3rd and $10 off the 4th -> 2 save $5, 3 save $15, 4 save $25. Whole dollars
  // in from section settings; cents everywhere below.
  var TA = DATA.toolAmts || [5, 10];
  var TOOL_AMTS = [TA[0] * 100, TA[1] * 100];
  if (isTools) {
    // hand-tool ladder PDP: add-ons ARE the other tools
    DATA.addons = (DATA.tools || []).filter(function (t) { return t.available && t.id !== DATA.seed.id; }).map(function (t) {
      return { id: t.id, title: t.title, img: t.img, planId: 0, variants: [{ id: t.variantId, title: 'One size', price: t.price, available: true }] };
    });
  }

  // ---- money ----
  var fmt = function (cents) {
    var v = (cents / 100);
    var s = v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (DATA.currencySymbol || '$') + s;
  };
  var fmtShort = function (cents) { return fmt(cents).replace(/\.00$/, ''); };

  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return document.querySelectorAll(s); };

  // ---- size filtering (5L groomers-only etc.) ----
  var excl = (DATA.excludeMatch || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  function allowedVariants(p) {
    return p.variants.filter(function (v) {
      if (!v.available) return false;
      var t = (v.title || '').toLowerCase();
      return !excl.some(function (x) { return x && t.indexOf(x) !== -1; });
    });
  }
  // seed size picker shows ALL available sizes (incl. 5L trade size);
  // excl list only filters add-on slot variants + gates offers on the seed.
  var seedVars = DATA.seed.variants.filter(function (v) { return v.available; });
  // Revision 11: never let an out-of-stock seed leave state.seedVar undefined.
  // The whole builder reads state.seedVar.price on its first pass, so an empty
  // list used to throw and freeze the page. Price it anyway; block the cart.
  var PS_SOLD_OUT = seedVars.length === 0;
  if (PS_SOLD_OUT) seedVars = DATA.seed.variants.slice(0, 1);
  var isHW = DATA.mode === 'hardware';
  var isBlade = isHW && !!DATA.isBlade;
  function isTrade(v) {
    var t = ((v && v.title) || '').toLowerCase();
    return excl.some(function (x) { return x && t.indexOf(x) !== -1; });
  }
  function tradeMode() { return !isHW && isTrade(state.seedVar); }

  // ---- state ----
  var state = {
    sub: false,
    freq: 0,
    seedVar: seedVars[0],
    nAddons: 0,                 // selected tier row = number of add-on slots
    slots: [],                  // [{productIdx, variantId}]
    bonus: false,               // bundle bonus (Purify Scrub @ 30% off) opted in — retired, always false
    pump: false,                // 5L extra pump add-on opted in
    qty: 1
  };

  // ---- bundle bonus (PT sharpener pattern) ----
  var BONUS = (!isHW && !isTools && DATA.bonus) ? DATA.bonus : null;
  function bonusUnlocked() { return !!BONUS && state.nAddons >= 1; }
  function bonusOn() { return bonusUnlocked() && state.bonus; }
  function bonusSave() { return bonusOn() ? Math.round(BONUS.price * (BONUS.pct / 100)) : 0; }
  function bonusNet() { return bonusOn() ? (BONUS.price - Math.round(BONUS.price * (BONUS.pct / 100))) : 0; }

  // ---- 5L extra pump add-on ----
  // Plain cross-sell at its own everyday price. Not in any SELLY offer, so no discount
  // is claimed and the price holds in every cart. Offered on the 5L (trade) size only,
  // to retail and wholesale alike. Always quantity 1.
  var PUMP = (!isHW && !isTools && DATA.pump) ? DATA.pump : null;
  function pumpShown() { return !!PUMP && tradeMode(); }
  function pumpOn() { return pumpShown() && state.pump; }
  function pumpNet() { return pumpOn() ? PUMP.price : 0; }

  function addonProduct(i) { return DATA.addons[state.slots[i].productIdx]; }
  function addonVariant(i) {
    var p = addonProduct(i);
    var id = state.slots[i].variantId;
    for (var k = 0; k < p.variants.length; k++) if (p.variants[k].id === id) return p.variants[k];
    return allowedVariants(p)[0];
  }

  // ---- discount math (locked model: pack tier, then sub % of remainder) ----
  // Cutter heads use a FLAT $ discount on EVERY head in the cart once there are 2+.
  // The FIRST head is always full price: 1 head -> $0, 2 -> $5 ea, 3 -> $10 ea, 4+ -> $15 ea.
  // DATA.hwAmts is in whole dollars (section settings hw_amt1/2/3 = the 2 / 3 / 4+ tiers).
  var HEAD_AMTS = (DATA.hwAmts && DATA.hwAmts.length === 3) ? DATA.hwAmts.slice() : [5, 10, 15];
  function headCount() { return state.nAddons + (isBlade ? 1 : 0); }
  function headSave(n) {
    if (n == null) n = headCount();
    if (n < 2) return 0;
    return n * Math.round((HEAD_AMTS[Math.min(n, 4) - 2] || 0) * 100);
  }
  // ---- SELLY consumption model (mirrors mn-cart-nudge.js discountFor) ----
  // SELLY consumes items largest-bundle-first, sorted by price DESC, and gives the
  // full-price slot to the MOST EXPENSIVE item in each chunk. Leftovers smaller than
  // the smallest bundle get nothing. Verified on real carts 4 Aug 2026.
  function ladderFor(kind) {
    var W = DATA.tierWorks, D = DATA.tierDuo, A2 = TOOL_AMTS[0], A3 = TOOL_AMTS[1];
    return kind === 'tools'
      ? [{ n: 4, a: [0, A2, A3, A3] }, { n: 3, a: [0, A2, A3] }, { n: 2, a: [0, A2] }]
      : [{ n: 4, r: [W, W, W, W] }, { n: 3, r: [W, W, W] }, { n: 2, r: [D, D] }];
  }
  // -> { save: cents, pcts: [effective % per item], amts: [cents off per item],
  //      both aligned to the ORIGINAL order }
  function bundlePlan(kind, prices) {
    var pcts = [], amts = [], i;
    for (i = 0; i < prices.length; i++) { pcts.push(0); amts.push(0); }
    if (tradeMode() || prices.length < 2) return { save: 0, pcts: pcts, amts: amts };
    if (DATA.flatPct > 0) {                              // Perfect Sense: one flat % on everything
      var fsave = 0;
      for (i = 0; i < prices.length; i++) {
        pcts[i] = DATA.flatPct;
        amts[i] = prices[i] * DATA.flatPct / 100;
        fsave += amts[i];
      }
      return { save: Math.floor(fsave + 0.0001), pcts: pcts, amts: amts };
    }
    var order = [];
    for (i = 0; i < prices.length; i++) order.push(i);
    order.sort(function (a, b) { return prices[b] - prices[a]; });
    var bundles = ladderFor(kind), save = 0, pos = 0;
    while (pos < order.length) {
      var rem = order.length - pos, chosen = null;
      for (i = 0; i < bundles.length; i++) if (bundles[i].n <= rem) { chosen = bundles[i]; break; }
      if (!chosen) break;
      for (var j = 0; j < chosen.n; j++) {
        var ix = order[pos + j];
        if (chosen.a) {                                   // flat dollars off this slot
          var amt = Math.min(chosen.a[j] || 0, prices[ix]);   // never below free
          amts[ix] = amt; save += amt;
          pcts[ix] = prices[ix] ? amt * 100 / prices[ix] : 0; // effective %, for callers that need one
        } else {
          var pc = chosen.r[j] || 0;
          pcts[ix] = pc; amts[ix] = prices[ix] * pc / 100; save += prices[ix] * pc / 100;
        }
      }
      pos += chosen.n;
    }
    return { save: Math.floor(save + 0.0001), pcts: pcts, amts: amts };
  }
  function packPrices() { // this product + its pack slots, in slot order
    var a = [state.seedVar.price];
    for (var i = 0; i < state.nAddons; i++) a.push(addonVariant(i).price);
    return a;
  }
  function packPlan() {
    var plan = bundlePlan(isTools ? 'tools' : 'liquids', packPrices());
    if (subReplacesBundle()) { // every pack line carries the selling plan, so none earns a tier
      var z = []; for (var zi = 0; zi < plan.pcts.length; zi++) z.push(0);
      return { save: 0, pcts: z, amts: z.slice() };
    }
    return plan;
  }
  function packDisc() {
    if (isHW) return 0; // hardware is flat $-per-head, not a percentage
    var items = 1 + state.nAddons;
    if (DATA.flatPct > 0) return items >= 2 ? DATA.flatPct / 100 : 0;
    if (items >= 3) return DATA.tierWorks / 100;
    if (items === 2) return DATA.tierDuo / 100;
    return 0;
  }
  function subDisc() {
    if (!state.sub || !DATA.subEnabled || isHW || isTools) return 0;
    if (tradeMode()) {
      if (!DATA.isWholesale) return 0;
      // Appstle wholesale trade plan: fixed subscription price (e.g. 5L at $67.60)
      if (state.seedVar.wsPrice > 0 && state.seedVar.price > 0 && state.seedVar.wsPrice < state.seedVar.price)
        return 1 - (state.seedVar.wsPrice / state.seedVar.price);
      return (DATA.subTradePct || 0) / 100;
    }
    return subFirstPct() / 100;
  }
  // Appstle retail plans: FIRST order at sub_first_pct (30%), renewals at the ongoing % (10%;
  // the Complete Set uses set_sub_pct). 0 = legacy flat % (first = ongoing). Wholesale untouched.
  function subOngoingPct() { return DATA.isSet ? (+DATA.setSubPct || 0) : (state.nAddons > 0 ? DATA.subPack : DATA.subSingle); }
  function subFirstPct() { return DATA.subFirst > 0 ? +DATA.subFirst : subOngoingPct(); }
  // sub_no_bundle: a subscribed line takes the first-order % INSTEAD of the multi-buy tier (never both).
  function subReplacesBundle() { return !!DATA.subNoBundle && state.sub && !tradeMode() && !isHW && !isTools; }
  function packDiscGated() { return tradeMode() ? 0 : packDisc(); }

  function plansFor() {
    if (isHW || isTools) return [];
    var ws = DATA.wsPlans || (DATA.seed && DATA.seed.wsPlans) || [];
    if (tradeMode() && DATA.isWholesale && ws.length) return ws;
    return DATA.plans || (DATA.seed && DATA.seed.plans) || [];
  }
  function freqLabel(name) {
    var m = /(\d+)\s*week/i.exec(name);
    if (m) return 'Every ' + m[1] + ' weeks';
    if (/month/i.test(name)) return 'Monthly';
    return (name || '').replace(/subscription/ig, '').trim() || name;
  }
  function chosenPlan() {
    var ps = plansFor();
    if (!ps.length) return null;
    if (state.freq >= ps.length) state.freq = 0;
    return ps[state.freq];
  }
  function renderFreq() {
    var wrap = $('#mn-freqwrap'), box = $('#mn-freq');
    if (!wrap || !box) return;
    var ps = plansFor();
    var show = state.sub && DATA.subEnabled && !isHW && !isTools && ps.length > 0;
    wrap.hidden = !show;
    if (!show) return;
    if (state.freq >= ps.length) state.freq = 0;
    box.innerHTML = '';
    ps.forEach(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fpill' + (i === state.freq ? ' on' : '');
      b.textContent = freqLabel(p.name);
      b.addEventListener('click', function () { state.freq = i; update(); });
      box.appendChild(b);
    });
  }

  // ---- trade-size gating (5L: no sub, no bundle, no bonus) ----
  function applyTradeMode() {
    var trade = tradeMode();
    var wsTrade = trade && DATA.isWholesale;
    var note = $('#mn-tradenote');
    if (note) {
      note.hidden = !trade;
      if (trade) note.textContent = (wsTrade ? note.getAttribute('data-ws') : note.getAttribute('data-retail')) || note.textContent;
    }
    // wholesale keeps the Subscribe field on 5L (repeat delivery at trade price)
    var subField = $('#mn-subfield'); if (subField) subField.hidden = trade && !DATA.isWholesale;
    var bundleField = $('#mn-bundlefield'); if (bundleField) bundleField.hidden = trade || (sellyWS && !isHW);
    updatePump();
    if (trade) {
      if (!DATA.isWholesale) {
        state.sub = false;
        $$('#mn-subseg .seg').forEach(function (s) { s.classList.toggle('on', s.dataset.sub === '0'); });
      }
      state.bonus = false;
      if (state.nAddons !== 0) { state.nAddons = 0; state.slots = []; renderBundle(); renderSlots(); }
    }
  }
  function discountBase() { // hardware: seed (clipper) never discounted
    var s = 0;
    for (var i = 0; i < state.nAddons; i++) s += addonVariant(i).price;
    if (!isHW) s += state.seedVar.price;
    return s;
  }
  function subtotal() {
    var s = state.seedVar.price;
    for (var i = 0; i < state.nAddons; i++) s += addonVariant(i).price;
    return s;
  }
  function rrpOf(v) { return v.rrp != null ? v.rrp : v.price; }
  function rrpSubtotal() { // pre-SELLY (RRP) subtotal, for strike-through display
    var s = rrpOf(state.seedVar);
    for (var i = 0; i < state.nAddons; i++) s += rrpOf(addonVariant(i));
    return s;
  }
  function packSave() {
    if (isHW) return headSave();
    return packPlan().save;
  }
  // Only the lines that actually carry a selling plan earn the subscription %,
  // and SELLY discounts the PLAN price, so the two multiply (verified at checkout).
  function subBase() {
    var plan = packPlan(), b = 0, i;
    if (!isHW) b += state.seedVar.price - (plan.amts[0] || 0);
    for (i = 0; i < state.nAddons; i++) {
      var p = addonProduct(i);
      if (p && ((p.plans && p.plans.length) || p.planId)) {
        b += addonVariant(i).price - (plan.amts[i + 1] || 0);
      }
    }
    return Math.round(b);
  }
  // Revision 12: the Complete Set has a real RRP behind its price. Show it.
  // Set page only -- on a single bottle a compare-at is not a "pack" saving.
  function setRrpSave() {
    if (!DATA.isSet) return 0;
    var v = state.seedVar || {}, c = +v.cmpAt || 0;
    return c > v.price ? c - v.price : 0;
  }
  function subSave() { return Math.round(subBase() * subDisc()); }
  function netTotal() { return subtotal() - packSave() - subSave(); }
  function grandTotal() { return (netTotal() + bonusNet() + toolsNet()) * state.qty + airlieNet() + pumpNet(); }

  // ---- bonus card wiring ----
  function initBonus() {
    if (!BONUS) return;
    var img = $('#mn-bonus-img'); if (img) { img.src = BONUS.img || ''; img.alt = BONUS.title || ''; }
    var t = $('#mn-bonus-title'); if (t) t.textContent = BONUS.title || '';
    var pct = $('#mn-bonus-pct'); if (pct) pct.textContent = BONUS.pct + '%';
    var now = $('#mn-bonus-now'); if (now) now.textContent = fmt(BONUS.price - Math.round(BONUS.price * (BONUS.pct / 100)));
    var was = $('#mn-bonus-was'); if (was) was.textContent = fmt(BONUS.price);
    var chk = $('#mn-bonus-check');
    if (chk) chk.onchange = function () { state.bonus = chk.checked; update(); };
  }
  function updateBonus() {
    var box = $('#mn-bonus'); if (!box) return;
    var show = bonusUnlocked();
    box.hidden = !show;
    if (!show && state.bonus) { state.bonus = false; var chk = $('#mn-bonus-check'); if (chk) chk.checked = false; }
  }

  // ---- pump card wiring ----
  function initPump() {
    var field = $('#mn-pumpfield');
    if (!PUMP) { if (field) field.remove(); return; }
    var img = $('#mn-pump-img'); if (img) { img.src = PUMP.img || ''; img.alt = PUMP.title || ''; }
    var t = $('#mn-pump-title'); if (t) t.textContent = PUMP.title || '';
    var now = $('#mn-pump-now'); if (now) now.textContent = fmt(PUMP.price);
    var was = $('#mn-pump-was');
    if (was) { var hasRrp = PUMP.rrp && PUMP.rrp > PUMP.price; was.hidden = !hasRrp; was.textContent = hasRrp ? fmt(PUMP.rrp) : ''; }
    var chk = $('#mn-pump-check');
    if (chk) chk.onchange = function () { state.pump = chk.checked; update(); };
  }
  function updatePump() {
    var field = $('#mn-pumpfield'); if (!field) return;
    var show = pumpShown();
    field.hidden = !show;
    if (!show && state.pump) { state.pump = false; var chk = $('#mn-pump-check'); if (chk) chk.checked = false; }
  }

  // ---- render seed size segs ----
  // parse a volume in ml from a variant title (e.g. "250ml", "1L", "5 Litre")
  function volMl(title) {
    var m = /([\d.]+)\s*(ml|l|litre|liter)s?\b/i.exec(title || '');
    if (!m) return 0;
    var n = parseFloat(m[1]);
    return /^ml$/i.test(m[2]) ? n : n * 1000;
  }
  function renderSizes() {
    var wrap = $('#mn-size');
    if (!wrap) return;
    // best value = lowest $/100ml among RETAIL sizes only (trade 5L excluded)
    var bestId = 0, bestUnit = Infinity;
    if (!isHW) {
      seedVars.forEach(function (v) {
        if (isTrade(v)) return;
        var ml = volMl(v.title);
        if (!ml) return;
        var u = v.price / ml;
        if (u < bestUnit) { bestUnit = u; bestId = v.id; }
      });
    }
    var html = '';
    seedVars.forEach(function (v) {
      var on = state.seedVar.id === v.id ? ' on' : '';
      var ml = volMl(v.title);
      var unit = (!isHW && !isTrade(v) && ml)
        ? '<div class="u tabular">' + fmt(Math.round(v.price / ml * 100)) + ' / 100ml</div>' : '';
      var badge = v.id === bestId ? '<span class="bv">Best value</span>' : '';
      html += '<div class="seg' + on + '" data-vid="' + v.id + '">' + badge + '<div class="t">' + v.title + '</div><div class="s tabular">' + fmtShort(v.price) + '</div>' + unit + '</div>';
    });
    wrap.innerHTML = html;
    wrap.querySelectorAll('.seg').forEach(function (el) {
      el.onclick = function () {
        wrap.querySelectorAll('.seg').forEach(function (s) { s.classList.remove('on'); });
        el.classList.add('on');
        state.seedVar = seedVars.filter(function (v) { return v.id === +el.dataset.vid; })[0];
        applyTradeMode();
        update();
      };
    });
  }

  // ---- Perfect Sense card picker (Melanie, 26 Aug 2026) ----
  // Each add-on is a box carrying its own product tile with the inspired-by
  // reference underneath, so the range sells itself from the page it is on.
  var CARD = !!DATA.cardPicker && DATA.addons.length > 0;
  function shortTitle(t) {
    return (t || '').replace(/^Perfect Sense\s+/i, '').replace(/\s+Pet (Perfume|Cologne)\s+\d+ml$/i, '').trim() || t;
  }
  // Running order value, pinned under the picker: every tap must move a number
  // the customer can see without hunting for the buy box.
  function updateTally() {
    var el = document.getElementById('mn-tally');
    if (!el) return;
    var n = 1 + state.nAddons;
    var full = subtotal(), save = packSave(), ssave = subSave(), net = full - save - ssave;
    var setPrice = DATA.setPack ? DATA.setPack.price : 0;
    var right = (save + ssave > 0 ? '<s class="tabular">' + fmt(full) + '</s>' : '') +
      '<b class="tabular">' + fmt(net) + '</b>';
    var note;
    if (save + ssave > 0) {
      note = 'You save ' + fmt(save + ssave) +
        (n >= DATA.addons.length + 1 && setPrice && net > setPrice
          ? ' \u00b7 the set is ' + fmt(setPrice) : '');
    } else {
      note = 'Add another and every bottle drops ' + DATA.flatPct + '%';
    }
    el.hidden = false;
    el.innerHTML = '<span class="ps-tally-n">' + n + (n === 1 ? ' bottle' : ' bottles') + '</span>' +
      '<span class="ps-tally-r">' + right + '</span>' +
      '<span class="ps-tally-s">' + note + '</span>';
  }
  function renderCards(wrap) {
    var picked = state.slots.map(function (s) { return s.productIdx; });
    var html = '<div class="ps-cards">';
    DATA.addons.forEach(function (ap, ai) {
      var av = allowedVariants(ap)[0];
      if (!av) return;
      var on = picked.indexOf(ai) > -1;
      html += '<button type="button" class="ps-card' + (on ? ' on' : '') + '" data-ai="' + ai + '" aria-pressed="' + on + '">' +
        '<span class="ps-card-tick" aria-hidden="true"></span>' +
        '<span class="ps-card-img"><img src="' + (ap.img || '') + '" alt="" loading="lazy"></span>' +
        '<span class="ps-card-t">' + shortTitle(ap.title) + '</span>' +
        (ap.insp ? '<span class="ps-card-k">Inspired by</span><span class="ps-card-i">' + ap.insp + '</span>' : '') +
        '<span class="ps-card-foot"><span class="ps-card-p tabular">' + fmtShort(av.price) + '</span>' +
        '<span class="ps-card-cta">' + (on ? 'Added \u2713' : '+ Add') + '</span></span>' +
        '</button>';
    });
    wrap.innerHTML = html + '</div><div class="ps-tally" id="mn-tally" aria-live="polite" hidden></div>';
    wrap.querySelectorAll('.ps-card').forEach(function (el) {
      el.onclick = function () { toggleCard(+el.dataset.ai); };
    });
  }
  function toggleCard(ai) {
    var at = -1, i;
    for (i = 0; i < state.slots.length; i++) if (state.slots[i].productIdx === ai) { at = i; break; }
    if (at > -1) state.slots.splice(at, 1);
    else {
      if (state.slots.length >= DATA.maxSlots) return;
      var p = DATA.addons[ai];
      state.slots.push({ productIdx: ai, variantId: (allowedVariants(p)[0] || p.variants[0]).id });
    }
    state.nAddons = state.slots.length;
    renderSlots(); update();
  }
  function renderSetCard(wrap) {
    var sp = DATA.setPack;
    if (!sp) { wrap.innerHTML = ''; return; }
    var imgs = [], thumbs = '';
    if (DATA.seed && DATA.seed.img) imgs.push(DATA.seed.img);
    DATA.addons.forEach(function (a) { if (a.img) imgs.push(a.img); });
    imgs.slice(0, 6).forEach(function (u) { thumbs += '<img src="' + u + '" alt="" loading="lazy">'; });
    var save = (sp.compareAt || 0) - sp.price;
    wrap.innerHTML = '<div class="ps-set">' +
      '<div class="ps-set-thumbs" aria-hidden="true">' + thumbs + '</div>' +
      '<div class="ps-set-main">' +
        '<div class="ps-set-t">' + (sp.title || 'The Complete Set') + '</div>' +
        '<div class="ps-set-s">' + (sp.sub || '') + '</div>' +
      '</div>' +
      '<div class="ps-set-buy">' +
        '<div class="ps-set-price"><span class="ps-set-now tabular">' + fmt(sp.price) + '</span>' +
        (sp.compareAt > sp.price ? '<span class="ps-set-was tabular">' + fmt(sp.compareAt) + '</span>' : '') + '</div>' +
        (save > 0 ? '<div class="ps-set-save">Save ' + fmt(save) + '</div>' : '') +
        '<button type="button" class="ps-set-btn" id="mn-set-add"><span>Add the set</span></button>' +
      '</div></div>';
    var b = $('#mn-set-add');
    if (b) b.onclick = function () { postItems(b, [{ id: sp.variantId, quantity: 1 }]); };
  }

  // ---- render pack tier rows (PT bundle pattern) ----
  function hwTag(nAdd, best) {
    var save = headSave(nAdd + (isBlade ? 1 : 0));
    if (save <= 0) return '';
    return 'Save ' + fmt(save) + ' on heads' + (best ? ' \u00b7 Best value' : '');
  }
  function worksTag() { // 3 or 4 items = flat %, 5+ chunks so quote the real $ saving
    if (state.nAddons > 2) { var sv = packPlan().save; return sv > 0 ? 'Save ' + fmt(sv) + ' \u00b7 Best value' : ''; }
    return 'Save ' + DATA.tierWorks + '% \u00b7 Best value';
  }
  function tierRows() {
    if (isTools) {
      return [
        { n: 0, t: 'Just this tool', s: 'Perfect on its own', tag: '' },
        { n: 1, t: '+ 1 more tool', s: 'Pair it with any tool in the range', tag: 'Save ' + fmtShort(TOOL_AMTS[0]) },
        { n: 2, t: '+ 2 or more tools', s: 'Build the full kit', tag: 'Save ' + fmtShort(TOOL_AMTS[0] + TOOL_AMTS[1]) + ' on 3, ' + fmtShort(TOOL_AMTS[0] + TOOL_AMTS[1] * 2) + ' on 4 \u00b7 Best value' }
      ];
    }
    if (isHW) {
      // Rows always climb to a 4-HEAD cart, where the $15-each top tier lands.
      // On a blade page the seed is itself a head, so 3 add-ons = 4 heads.
      var hw = [
        { n: 0, t: isBlade ? 'This blade only' : 'Clipper only', s: 'Just the ' + DATA.seed.title, tag: hwTag(0) },
        { n: 1, t: '+ 1 cutter head', s: 'Your everyday blend', tag: hwTag(1) },
        { n: 2, t: '+ 2 cutter heads', s: 'Cover more coat lengths', tag: hwTag(2) }
      ];
      if (isBlade) {
        hw.push({ n: 3, t: '+ 3 cutter heads', s: 'The full kit', tag: hwTag(3, true) });
      } else {
        hw.push({ n: 3, t: '+ 3 cutter heads', s: 'Cover the whole coat', tag: hwTag(3) });
        hw.push({ n: 4, t: '+ 4 cutter heads', s: 'The full kit', tag: hwTag(4, true) });
      }
      return hw;
    }
    return [
      { n: 0, t: 'Just this one', s: 'Perfect to start', tag: '' },
      { n: 1, t: 'Duo — add 1 more', s: 'Pair it with anything in the range', tag: 'Save ' + DATA.tierDuo + '%' },
      { n: 2, t: 'The Works — add 2+', s: 'The complete routine', tag: worksTag() }
    ];
  }
  function renderBundle() {
    var wrap = $('#mn-bundle');
    if (!wrap) return;   // set page removes the builder outright
    if (CARD) { renderSetCard(wrap); return; }
    var html = '';
    var rows = tierRows(), lastN = rows.length ? rows[rows.length - 1].n : 0;
    rows.forEach(function (r) {
      var on = state.nAddons === r.n || (r.n === lastN && state.nAddons > lastN) ? ' on' : '';
      html += '<div class="brow' + on + '" data-n="' + r.n + '">' +
        (r.tag ? '<span class="btag">' + r.tag + '</span>' : '') +
        '<span class="radio"></span>' +
        '<div class="bmain"><div class="bt">' + r.t + '</div><div class="bs">' + r.s + '</div></div>' +
        '<div class="bprice"><div class="bp tabular"></div><div class="bc tabular"></div></div></div>';
    });
    wrap.innerHTML = html;
    wrap.querySelectorAll('.brow').forEach(function (row) {
      row.onclick = function () {
        setAddonCount(+row.dataset.n);
      };
    });
  }
  function setAddonCount(n) {
    state.nAddons = n;
    while (state.slots.length < n) {
      var idx = state.slots.length % Math.max(DATA.addons.length, 1);
      var p = DATA.addons[idx];
      state.slots.push({ productIdx: idx, variantId: p ? (allowedVariants(p)[0] || p.variants[0]).id : 0 });
    }
    state.slots.length = Math.max(n, state.slots.length > n ? n : state.slots.length);
    renderBundle(); renderSlots(); update();
  }

  // ---- per-slot pickers: product select + size mini-segs (PT boards pattern) ----
  function renderSlots() {
    var wrap = $('#mn-slots');
    if (!wrap) return;   // set page removes the builder outright
    if (!DATA.addons.length) { wrap.innerHTML = ''; return; }
    if (CARD) { renderCards(wrap); return; }
    var html = '';
    for (var b = 0; b < state.nAddons; b++) {
      var p = addonProduct(b);
      var label = isHW ? 'Head ' + (b + 1) : (isTools ? 'Tool ' + (b + 1) : 'Add-on ' + (b + 1));
      html += '<div class="bsel"><div class="bl">' + label + ' — choose product</div>';
      html += '<div class="slot-prod"><img src="' + (p.img || '') + '" alt="" loading="lazy"><select data-slot="' + b + '" aria-label="' + label + '">';
      DATA.addons.forEach(function (ap, ai) {
        var av = allowedVariants(ap)[0];
        if (!av) return;
        html += '<option value="' + ai + '"' + (ai === state.slots[b].productIdx ? ' selected' : '') + '>' + ap.title + ' \u2014 ' + fmtShort(av.price).replace(/</g, '&lt;') + (ap.variants.length > 1 ? '+' : '') + '</option>';
      });
      html += '</select></div>';
      var avs = allowedVariants(p);
      if (avs.length > 1) {
        html += '<div class="mini" data-slot="' + b + '">';
        avs.forEach(function (v) {
          var on = state.slots[b].variantId === v.id ? ' on' : '';
          html += '<div class="mseg' + on + '" data-slot="' + b + '" data-vid="' + v.id + '"><b>' + v.title + '</b><span class="tabular">' + fmtShort(v.price) + '</span></div>';
        });
        html += '</div>';
      }
      html += '</div>';
    }
    // "+ add another" inside Works tier
    var canGrow = !isHW ? (state.nAddons >= 2 && state.nAddons < DATA.maxSlots) : (state.nAddons >= 3 && state.nAddons < DATA.maxSlots);
    if (canGrow && DATA.addons.length) html += '<button type="button" class="slot-add" id="mn-slot-add">+ Add another</button>';
    wrap.innerHTML = html;

    wrap.querySelectorAll('select').forEach(function (sel) {
      sel.onchange = function () {
        var b = +sel.dataset.slot, ai = +sel.value;
        var p = DATA.addons[ai];
        state.slots[b] = { productIdx: ai, variantId: (allowedVariants(p)[0] || p.variants[0]).id };
        renderSlots(); update();
      };
    });
    wrap.querySelectorAll('.mseg').forEach(function (el) {
      el.onclick = function () {
        state.slots[+el.dataset.slot].variantId = +el.dataset.vid;
        renderSlots(); update();
      };
    });
    var grow = $('#mn-slot-add');
    if (grow) grow.onclick = function () { setAddonCount(state.nAddons + 1); };
  }

  // ---- subscribe seg ----
  $$('#mn-subseg .seg').forEach(function (seg) {
    seg.onclick = function () {
      $$('#mn-subseg .seg').forEach(function (s) { s.classList.remove('on'); });
      seg.classList.add('on');
      state.sub = seg.dataset.sub === '1';
      update();
    };
  });

  // ---- qty ----
  var qplus = $('#mn-qplus'), qminus = $('#mn-qminus'), qinput = $('#mn-qty');
  if (qplus) qplus.onclick = function () { state.qty = Math.min(state.qty + 1, 9); qinput.value = state.qty; update(); };
  if (qminus) qminus.onclick = function () { state.qty = Math.max(state.qty - 1, 1); qinput.value = state.qty; update(); };

  // ---- gallery thumbs ----
  $$('#mn-thumbs .thumb').forEach(function (t) {
    t.onclick = function () {
      $$('#mn-thumbs .thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var img = $('#mn-gmain'); if (img) img.src = t.dataset.src;
    };
  });

  // ---- faq ----
  $$('#mn-faq .qa button').forEach(function (btn) {
    btn.onclick = function () {
      var qa = btn.parentElement, ans = qa.querySelector('.ans');
      var open = qa.classList.contains('open');
      qa.classList.toggle('open', !open);
      ans.style.maxHeight = open ? null : ans.scrollHeight + 'px';
    };
  });

  // ---- update bundle row prices + all totals ----
  function updateBundleRows() {
    $$('#mn-bundle .brow').forEach(function (row) {
      var n = +row.dataset.n;
      // preview totals for that tier using current selections (fill hypothetical slots with slot-0 pattern)
      var save = state.nAddons, saveSlots = state.slots.slice();
      state.nAddons = n;
      while (state.slots.length < n && DATA.addons.length) {
        var idx = state.slots.length % DATA.addons.length;
        var p = DATA.addons[idx];
        state.slots.push({ productIdx: idx, variantId: (allowedVariants(p)[0] || p.variants[0]).id });
      }
      var full = subtotal(), net = netTotal();
      state.nAddons = save; state.slots = saveSlots;
      var bp = row.querySelector('.bp'); if (bp) bp.textContent = fmt(net);
      var bc = row.querySelector('.bc'); if (bc) bc.textContent = net < full ? fmt(full) : '';
    });
  }

  // Bundle + subscription stack on the FIRST order only (SELLY discounts the subscription
  // line once; Appstle then renews at the plan price). Say so plainly, in both directions.
  function firstOrderNote() {
    var band = $('#mn-saveband'); if (!band || !band.parentNode) return;
    var el = document.getElementById('mn-firstnote');
    if (!el) {
      el = document.createElement('div');
      el.id = 'mn-firstnote';
      el.setAttribute('style', 'font-size:12px;line-height:1.45;color:#6b6b6b;margin-top:8px');
      band.parentNode.insertBefore(el, band.nextSibling);
    }
    var pct = state.sub ? subOngoingPct() : 0;
    var show = state.sub && !tradeMode() && packSave() > 0 && pct > 0;
    el.hidden = !show;
    el.innerHTML = show
      ? 'Your pack saving of <b>' + fmt(packSave()) + '</b> applies to this first delivery. After that, repeat deliveries renew at your Subscribe &amp; Save price (' + pct + '% off) — change, pause or cancel anytime.'
      : '';
  }
  function update() {
    renderFreq();
    updateBundleRows();
    if (!isHW && !isTools) { // keep "The Works" tag honest when the pack grows past 4 items
      var wrow = document.querySelector('#mn-bundle .brow[data-n="2"] .btag');
      if (wrow) wrow.innerHTML = worksTag();
    }
    updateBonus();
    updatePump();
    // pump is added at the same figure on both sides: it carries no bundle/sub discount,
    // so it must never inflate the strike-through or the savings equation.
    var pumpAmt = pumpNet();
    var rrpSave = setRrpSave();
    var full = subtotal() + rrpSave + (bonusOn() ? BONUS.price : 0) + toolsFull() + airlieNet() + pumpAmt, net = netTotal() + bonusNet() + toolsNet() + airlieNet() + pumpAmt;
    var priceEl = $('#mn-price'); if (priceEl) priceEl.textContent = fmt(net);
    var wasEl = $('#mn-was');
    if (wasEl) { wasEl.hidden = net >= full; wasEl.textContent = net < full ? fmt(full) : ''; }
    // equation band (pack + sub + bonus)
    var band = $('#mn-saveband'), ps = packSave() + bonusSave() + toolsSave() + rrpSave, ss = subSave();
    if (band) {
      band.hidden = (ps + ss) <= 0;
      var pEl = $('#mn-pack-save'); if (pEl) pEl.textContent = fmt(ps);
      var sCell = $('#mn-sub-cell'), plus = $('#mn-eq-plus'), pCell = $('#mn-pack-cell');
      if (sCell) sCell.style.display = ss > 0 ? '' : 'none';
      // a $0.00 term is noise: hide the cell, and the "+" unless both sides are real
      if (pCell) pCell.style.display = ps > 0 ? '' : 'none';
      if (plus) plus.style.display = (ps > 0 && ss > 0) ? '' : 'none';
      var pLbl = $('#mn-pack-lbl');
      if (pLbl) pLbl.textContent = DATA.isSet ? 'Set saving' : 'Pack saving';
      var sEl = $('#mn-sub-save'); if (sEl) sEl.textContent = fmt(ss);
      var tEl = $('#mn-total-save'); if (tEl) tEl.textContent = fmt(ps + ss);
    }
    firstOrderNote();
    updateTally();
    var total = grandTotal();
    ['#mn-atctot', '#mn-atctot2', '#mn-stot'].forEach(function (sel) {
      var el = $(sel); if (el) el.textContent = fmt(total);
    });
    // Revision 11: nothing in stock -> say so plainly instead of offering an
    // add Shopify would reject. Rewritten once, not on every update pass.
    if (PS_SOLD_OUT) ['#mn-atc', '#mn-atc2'].forEach(function (sel) {
      var b = $(sel);
      if (!b || b.disabled) return;
      b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
      b.classList.add('atc--sold');
      b.innerHTML = '<span>Sold out</span>';
    });
    // sticky summary
    var setl = state.nAddons === 0 ? (isTools ? 'Just this tool' : 'Just this one') : (isHW ? '+' + state.nAddons + ' head' + (state.nAddons > 1 ? 's' : '') : (isTools ? (1 + state.nAddons) + '-tool kit' : (1 + state.nAddons) + '-pack'));
    if (state.tools.length) setl += ' \u00b7 +' + state.tools.length + ' tool' + (state.tools.length > 1 ? 's' : '');
    if (airlieVar()) setl += ' \u00b7 + Airlie clipper';
    var q = state.qty > 1 ? ' ×' + state.qty : '';
    var sum = $('#mn-ssummary'); if (sum) sum.textContent = setl + (state.sub ? ' · Subscribe & Save' : '') + q;
    // sub seg: show the exact saving Subscribe & Save gives right now
    var up = $('#mn-sub-badge'), subSub = $('#mn-sub-sub');
    if (up && !isHW && !isTools && DATA.subEnabled) {
      if (tradeMode() && DATA.isWholesale && state.seedVar.wsPrice > 0 && state.seedVar.wsPrice < state.seedVar.price) {
        var tsave = state.seedVar.price - state.seedVar.wsPrice;
        up.textContent = 'SAVE ' + fmt(tsave);
        if (subSub) subSub.textContent = 'Trade subscription price ' + fmt(state.seedVar.wsPrice) + ' on every order · cancel anytime';
      } else {
        var pct = tradeMode() ? (DATA.isWholesale ? (DATA.subTradePct || 0) : 0) : subFirstPct();
        var ongoing = tradeMode() ? pct : subOngoingPct();
        // when subscription replaces the tiers, the first-order % is quoted on the undiscounted pack
        var hypoBase = (!tradeMode() && DATA.subNoBundle) ? discountBase() : (discountBase() - packSave());
        var hypo = Math.round(hypoBase * (pct / 100));
        up.textContent = pct > 0 ? 'SAVE ' + pct + '%' : 'REPEAT';
        if (subSub) subSub.textContent = hypo > 0
          ? (pct !== ongoing
              ? 'Save ' + fmt(hypo) + ' on this first order, then ' + ongoing + '% off every delivery · cancel anytime'
              : (packSave() > 0
                  ? 'Save an extra ' + fmt(hypo) + ' on this order, then ' + pct + '% off every repeat delivery · cancel anytime'
                  : 'Save an extra ' + fmt(hypo) + ' on every order · cancel anytime'))
          : 'Delivered on your schedule · cancel anytime';
        var subRep = subReplacesBundle();
        $$('#mn-bundle .brow .btag').forEach(function (t) { t.hidden = subRep; });
        var bh = $('#mn-bundlefield .flabel .v');
        if (bh) {
          if (!bh.getAttribute('data-ot')) bh.setAttribute('data-ot', bh.innerHTML);
          bh.innerHTML = subRep ? 'Subscribe &amp; Save ' + pct + '% applies to every item in your pack' : bh.getAttribute('data-ot');
        }
      }
    }
  }

  // ---- ADD TO CART (live AJAX, selling plan aware) ----
  // Hidden `_`-prefixed line properties let the MNSE Bundle Discount Function
  // recognise each line server-side and apply the same saving the builder shows.
  // Roles: cons | tool | head | anchor (never discounted) | bonus | trade (5L, ignored)
  function packProps(role, opts) {
    opts = opts || {};
    var p = { _mnpack: role, _mnpack_id: state.packId };
    if (opts.seq != null) p._mnpack_seq = String(opts.seq);
    if (opts.sub) p._mnpack_sub = '1';
    if (opts.pct != null) p._mnpack_pct = String(opts.pct);
    return p;
  }
  function consRole() { return tradeMode() ? 'trade' : 'cons'; }

  function buildItems() {
    // new bundle instance id so separate builds never merge in the cart
    state.packId = 'mn' + Date.now().toString(36) + Math.floor(Math.random() * 1e4).toString(36);
    var items = [];
    var seedItem = { id: state.seedVar.id, quantity: state.qty };
    var chosenFreq = chosenPlan();
    var seedPlan = chosenFreq ? chosenFreq.id : ((tradeMode() && DATA.isWholesale && DATA.wsPlanId) ? DATA.wsPlanId : DATA.seed.planId);
    if (state.sub && !isHW && seedPlan) seedItem.selling_plan = seedPlan;
    seedItem.properties = isHW
      ? packProps('anchor')
      : (isTools ? packProps('tool', { seq: 0 })
                 : packProps(consRole(), { sub: !!seedItem.selling_plan }));
    items.push(seedItem);
    var map = {}; // key variantId|plan -> item
    for (var i = 0; i < state.nAddons; i++) {
      var v = addonVariant(i), p = addonProduct(i);
      var key = v.id;
      if (map[key]) { map[key].quantity += state.qty; continue; }
      var it = { id: v.id, quantity: state.qty };
      if (state.sub && !isHW) {
        var apid = 0;
        if (chosenFreq && p.plans && p.plans.length) {
          for (var pi = 0; pi < p.plans.length; pi++) {
            if (String(p.plans[pi].name).toLowerCase() === String(chosenFreq.name).toLowerCase()) { apid = p.plans[pi].id; break; }
          }
          if (!apid) apid = p.plans[0].id;
        }
        if (!apid) apid = p.planId;
        if (apid) it.selling_plan = apid;
      }
      it.properties = isHW
        ? packProps('head')
        : (isTools ? packProps('tool', { seq: i + 1 })
                   : packProps(consRole(), { sub: !!it.selling_plan }));
      map[key] = it; items.push(it);
    }
    for (var t = 0; t < state.tools.length; t++) {
      var tvid = toolAt(t).variantId, ex = null;
      for (var j2 = 0; j2 < items.length; j2++) if (items[j2].id === tvid && !items[j2].selling_plan) ex = items[j2];
      if (ex) ex.quantity += state.qty; else items.push({ id: tvid, quantity: state.qty, properties: packProps('tool', { seq: t }) });
    }
    var av = airlieVar();
    if (av) {
      var aex = null;
      for (var j3 = 0; j3 < items.length; j3++) if (items[j3].id === av.id && !items[j3].selling_plan) aex = items[j3];
      if (aex) aex.quantity += 1; else items.push({ id: av.id, quantity: 1, properties: packProps('anchor') });
    }
    if (pumpOn()) {
      var pex = null;
      for (var j4 = 0; j4 < items.length; j4++) if (items[j4].id === PUMP.variantId && !items[j4].selling_plan) pex = items[j4];
      if (!pex) items.push({ id: PUMP.variantId, quantity: 1 });
    }
    if (bonusOn()) {
      var existing = null;
      for (var j = 0; j < items.length; j++) if (items[j].id === BONUS.variantId && !items[j].selling_plan) existing = items[j];
      if (existing) existing.quantity += state.qty;
      else items.push({ id: BONUS.variantId, quantity: state.qty, properties: packProps('bonus', { pct: BONUS.pct }) });
    }
    return items;
  }

  function notifyDrawer(cart) {
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { cart: cart } })); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    try { document.body.dispatchEvent(new CustomEvent('product:added', { bubbles: true })); } catch (e) {}
  }

  // Slide-out cart. UpCart is the store's cart drawer; the Fluorescent fly-out is
  // a fallback if UpCart is ever removed. Only fall back to /cart if neither exists.
  function openDrawer(cart, flashId) {
    if (typeof window.upcartRefreshCart === 'function' && typeof window.upcartOpenCart === 'function') {
      try {
        window.upcartRefreshCart();
        setTimeout(function () { window.upcartOpenCart(); }, 60);
        return true;
      } catch (e) {}
    }
    var flu = window.__mnFlu;
    var node = document.querySelector('[data-quick-cart]');
    if (flu && node && document.body.getAttribute('data-enable-quick-cart') === 'true') {
      try {
        cart.sorted = cart.items;
        flu.emit('cart:updated', { cart: cart });
        flu.emit('cart:open', null, { flash: flashId });
        return true;
      } catch (e) {}
    }
    return false;
  }

  // keep the theme's own "most recently added first" ordering honest
  function rememberOrder(ids) {
    try {
      var prev = JSON.parse(localStorage.getItem('neon_cart_order') || '[]') || [];
      var next = ids.concat(prev.filter(function (i) { return ids.indexOf(i) === -1; }));
      localStorage.setItem('neon_cart_order', JSON.stringify(next));
    } catch (e) {}
  }

  function doAdd(btn) { postItems(btn, buildItems()); }
  function postItems(btn, items) {
    if (!items.length) return;
    var original = btn.innerHTML;
    btn.disabled = true; btn.classList.add('loading');
    btn.innerHTML = '<span>Adding…</span>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      notifyDrawer(cart);
      btn.classList.remove('loading');
      btn.innerHTML = '<span>Added ✓</span>';
      rememberOrder(items.map(function (i) { return i.id; }));
      var opened = openDrawer(cart, items.length === 1 ? items[0].id : null);
      setTimeout(function () {
        btn.disabled = false; btn.innerHTML = original;
        if (!opened) window.location.href = '/cart';
      }, 900);
    }).catch(function (err) {
      btn.classList.remove('loading');
      btn.innerHTML = '<span>' + (err.message || 'Try again') + '</span>';
      setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 2200);
    });
  }
  if (DATA.isSet) {
    var rm = ['#mn-bundlefield', '#mn-toolsfield'];
    // Subscribe & Save only survives on the set page if a selling plan is
    // actually attached to the set product — never offer a plan that isn't there.
    if (!plansFor().length) rm.push('#mn-subfield');
    rm.forEach(function (sel) {
      var el = $(sel); if (el) el.remove();
    });
  }
  ['#mn-atc', '#mn-atc2'].forEach(function (sel) {
    var b = $(sel); if (b) b.onclick = function () { doAdd(b); };
  });

  // ---- sticky ATC reveal ----
  var sticky = $('#mn-sticky'), buybox = $('#mn-buybox');
  // lift sticky above Shopify's theme-preview toolbar so it stays visible during draft review
  setTimeout(function () {
    if (!sticky) return;
    var pb = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe, [id*="preview-bar"]');
    if (pb) { var h = pb.getBoundingClientRect().height || 48; sticky.style.bottom = h + 'px'; }
  }, 2500);
  if (sticky && buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buybox);
  }

  // ---- scroll reveal ----
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  // ---- grooming tools quick-shop popup (consumables PDPs only) ----
  var TOOLS = [];
  function thumbCluster(imgs) {
    var h = '';
    for (var i = 0; i < imgs.length && i < 3; i++) if (imgs[i]) h += '<img src="' + imgs[i] + '" alt="" loading="lazy">';
    return h ? '<span class="to-thumbs">' + h + '</span>' : '';
  }
  state.tools = [];
  function toolAt(pos) { return TOOLS[state.tools[pos]]; }
  function toolPrices() { var a = []; for (var i = 0; i < state.tools.length; i++) a.push(toolAt(i).price); return a; }
  function toolPlan() { return bundlePlan('tools', toolPrices()); }
  function toolPct(pos) { return toolPlan().pcts[pos] || 0; }
  function toolAmt(pos) { return toolPlan().amts[pos] || 0; }
  function toolsFull() { var s = 0; for (var i = 0; i < state.tools.length; i++) s += rrpOf(toolAt(i)); return s; }
  function toolsSave() { return toolPlan().save; }
  function toolsNet() { var s = 0; for (var i = 0; i < state.tools.length; i++) s += toolAt(i).price; return s - toolsSave(); }
  (function initToolsPopup() {
    var openBtn = $('#mn-tools-open');
    var field = $('#mn-toolsfield');
    if (!openBtn || isHW || isTools) return;
    TOOLS = (DATA.tools || []).filter(function (t) { return t.available && t.id !== DATA.seed.id; });
    if (!TOOLS.length) { if (field) field.hidden = true; return; }
    var modal = $('#mn-tools-modal'), grid = $('#mn-tools-grid');
    function openM() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function closeM() { modal.hidden = true; document.body.style.overflow = ''; }
    openBtn.onclick = openM;
    modal.querySelectorAll('[data-close]').forEach(function (el) { el.onclick = closeM; });
    var done = $('#mn-tools-done'); if (done) done.onclick = closeM;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeM(); });
    function renderTools() {
      var plan = toolPlan();
      grid.innerHTML = TOOLS.map(function (t, i) {
        var pos = state.tools.indexOf(i), on = pos > -1;
        var off = on ? (plan.amts[pos] || 0) : 0;
        var net = Math.max(0, t.price - off);
        var badge = on ? (off > 0 ? '<span class="tc-badge">' + fmtShort(off) + ' off</span>' : '<span class="tc-badge tc-full">Full price</span>') : '';
        return '<button type="button" class="toolcard' + (on ? ' on' : '') + '" data-i="' + i + '">' + badge +
          '<span class="tc-imgwrap"><img src="' + (t.img || '') + '" alt="" loading="lazy"></span>' +
          '<span class="tc-t">' + t.title + '</span>' +
          '<span class="tc-p tabular">' + (on && off > 0 ? '<b>' + fmtShort(net) + '</b> <s>' + fmtShort(t.price) + '</s>' : '<b>' + fmtShort(t.price) + '</b>') + '</span>' +
          '<span class="tc-add">' + (on ? '\u2713 Added' : '+ Add') + '</span></button>';
      }).join('');
      grid.querySelectorAll('.toolcard').forEach(function (c) {
        c.onclick = function () {
          var i = +c.dataset.i, pos = state.tools.indexOf(i);
          if (pos > -1) state.tools.splice(pos, 1); else state.tools.push(i);
          renderTools(); update();
        };
      });
      var n = state.tools.length;
      var tot = $('#mn-tools-tot');
      if (tot) tot.innerHTML = n
        ? n + ' tool' + (n > 1 ? 's' : '') + ' \u00b7 <b class="tabular">' + fmt(toolsNet()) + '</b>' + (toolsSave() > 0 ? ' <span class="tc-save">you save ' + fmt(toolsSave()) + '</span>' : '')
        : 'No tools selected';
      var sum = $('#mn-tools-summary');
      if (sum) {
        sum.hidden = !n;
        if (n) {
          var simgs = [];
          for (var sp = 0; sp < state.tools.length; sp++) if (toolAt(sp).img) simgs.push(toolAt(sp).img);
          sum.innerHTML = thumbCluster(simgs) + '<b>' + n + ' tool' + (n > 1 ? 's' : '') + ' added</b> \u2014 <span class="tabular">' + fmt(toolsNet()) + '</span>' + (toolsSave() > 0 ? ' <span class="tc-save">saving ' + fmt(toolsSave()) + '</span>' : '') + ' <a href="#" id="mn-tools-edit">Edit</a>';
          var ed = document.getElementById('mn-tools-edit');
          if (ed) ed.onclick = function (ev) { ev.preventDefault(); openM(); };
        }
      }
    }
    var tth = document.getElementById('mn-tools-thumbs');
    if (tth) {
      var timgs = [];
      for (var ti = 0; ti < TOOLS.length && timgs.length < 3; ti++) if (TOOLS[ti].img) timgs.push(TOOLS[ti].img);
      var th = '';
      for (var tj = 0; tj < timgs.length; tj++) th += '<img src="' + timgs[tj] + '" alt="" loading="lazy">';
      tth.innerHTML = th;
    }
    renderTools();
  })();
  // ---- Airlie clipper quick-add popup (blade PDPs only) ----
  var AIRLIE = (isBlade && DATA.airlie) ? DATA.airlie : null;
  state.airlie = -1; // index into AIRLIE.variants, -1 = not added
  function airlieVar() { return (AIRLIE && state.airlie > -1) ? AIRLIE.variants[state.airlie] : null; }
  function airlieNet() { var v = airlieVar(); return v ? v.price : 0; }
  (function initAirliePopup() {
    var openBtn = $('#mn-airlie-open'), field = $('#mn-airliefield');
    if (!openBtn) return;
    if (!AIRLIE) { if (field) field.hidden = true; return; }
    var avars = [];
    AIRLIE.variants.forEach(function (v, i) { if (v.available) { v.__idx = i; avars.push(v); } });
    if (!avars.length) { if (field) field.hidden = true; return; }
    var modal = $('#mn-airlie-modal'), grid = $('#mn-airlie-grid');
    function openM() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function closeM() { modal.hidden = true; document.body.style.overflow = ''; }
    openBtn.onclick = openM;
    modal.querySelectorAll('[data-close]').forEach(function (el) { el.onclick = closeM; });
    var done = $('#mn-airlie-done'); if (done) done.onclick = closeM;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeM(); });
    function cardTitle(v) { return (v.title && v.title !== 'Default Title') ? AIRLIE.title + ' \u2014 ' + v.title : AIRLIE.title; }
    function renderAirlie() {
      grid.innerHTML = avars.map(function (v) {
        var on = state.airlie === v.__idx;
        return '<button type="button" class="toolcard' + (on ? ' on' : '') + '" data-i="' + v.__idx + '">' +
          '<span class="tc-imgwrap"><img src="' + (AIRLIE.img || '') + '" alt="" loading="lazy"></span>' +
          '<span class="tc-t">' + cardTitle(v) + '</span>' +
          '<span class="tc-p tabular"><b>' + fmtShort(v.price) + '</b></span>' +
          '<span class="tc-add">' + (on ? '\u2713 Added' : '+ Add') + '</span></button>';
      }).join('');
      grid.querySelectorAll('.toolcard').forEach(function (c) {
        c.onclick = function () {
          var i = +c.dataset.i;
          state.airlie = state.airlie === i ? -1 : i;
          renderAirlie(); update();
        };
      });
      var on = state.airlie > -1;
      var tot = $('#mn-airlie-tot');
      if (tot) tot.innerHTML = on ? 'Airlie clipper \u00b7 <b class="tabular">' + fmt(airlieNet()) + '</b>' : 'Not added';
      var sum = $('#mn-airlie-summary');
      if (sum) {
        sum.hidden = !on;
        if (on) {
          sum.innerHTML = thumbCluster([AIRLIE.img]) + '<b>Airlie clipper added</b> \u2014 <span class="tabular">' + fmt(airlieNet()) + '</span> <a href="#" id="mn-airlie-edit">Edit</a>';
          var ed = document.getElementById('mn-airlie-edit');
          if (ed) ed.onclick = function (ev) { ev.preventDefault(); openM(); };
        }
      }
    }
    renderAirlie();
  })();

  // eq band label for tools mode
  if (isTools) { var lbl = document.querySelector('#mn-saveband .pt-bonus-lbl'); if (lbl) lbl.textContent = 'Kit saving'; }

  /* ===== SELLY (Treedify) wholesale & promo price sync =====
     SELLY broadcasts its full offer config through window.tdfEventHub as a
     sticky 'data_app2' event. Group-1 offers with discount type 7 are fixed
     "Your Price" rules (wholesale segment-gated, or public promos). We fold
     those prices into the engine so every tile/total matches checkout. */
  function sellyApply(cfg) {
    if (!cfg || !cfg.offers || !cfg.offers['1']) return;
    var now = Math.floor(Date.now() / 1000);
    function segOK(ids) {
      if (!ids || !ids.length) return true; // public promo
      if (!DATA.isWholesale) return false;
      for (var i = 0; i < ids.length; i++) {
        var sg = (cfg.sgm || {})[ids[i]];
        if (!sg || !sg.r) continue;
        for (var j = 0; j < sg.r.length; j++) {
          var r = sg.r[j] || {};
          if (r.column === 1 && /wholesale/i.test(r.value || '')) return true;
        }
      }
      return false;
    }
    function schOK(ids) {
      if (!ids || !ids.length) return true;
      var found = false;
      for (var i = 0; i < ids.length; i++) {
        var sc = (cfg.schedules || {})[ids[i]];
        if (!sc) continue;
        found = true;
        var st = (sc.st && sc.st.s) || 0, et = (sc.et && sc.et.s) || 0;
        if (st <= now && (!et || et > now)) return true;
      }
      return !found; // unknown schedule ids: don't block
    }
    var vMap = {}, pMap = {};
    var grp = cfg.offers['1'];
    Object.keys(grp).forEach(function (k) {
      var off = grp[k] || {}, d = off.discount || {}, trg = off.trigger || {};
      if (d.type_id !== 7 || typeof d.value !== 'number') return;
      if (!segOK(trg.segment_ids) || !schOK(trg.schedule_ids)) return;
      var cents = Math.round(d.value * 100);
      (off.product_groups || []).forEach(function (pg) {
        if (pg.pvids) {
          Object.keys(pg.pvids).forEach(function (pid) {
            (pg.pvids[pid] || []).forEach(function (vid) { if (vMap[vid] == null || cents < vMap[vid]) vMap[vid] = cents; });
          });
        } else if (pg.ids) {
          pg.ids.forEach(function (pid) { if (pMap[pid] == null || cents < pMap[pid]) pMap[pid] = cents; });
        }
      });
    });
    var touched = false;
    function rp(pid, v) {
      var ws = vMap[v.id] != null ? vMap[v.id] : pMap[pid];
      if (ws != null && ws > 0 && ws < v.price) { if (v.rrp == null) v.rrp = v.price; v.price = ws; touched = true; }
    }
    DATA.seed.variants.forEach(function (v) { rp(DATA.seed.id, v); });
    DATA.addons.forEach(function (p) { (p.variants || []).forEach(function (v) { rp(p.id, v); }); });
    (DATA.tools || []).forEach(function (t) {
      var ws = vMap[t.variantId] != null ? vMap[t.variantId] : pMap[t.id];
      if (ws != null && ws > 0 && ws < t.price) { if (t.rrp == null) t.rrp = t.price; t.price = ws; touched = true; }
    });
    if (DATA.airlie && DATA.airlie.variants) DATA.airlie.variants.forEach(function (v) { rp(DATA.airlie.id, v); });
    if (BONUS) {
      var wsb = vMap[BONUS.variantId] != null ? vMap[BONUS.variantId] : pMap[BONUS.id];
      if (wsb != null && wsb > 0 && wsb < BONUS.price) { if (BONUS.rrp == null) BONUS.rrp = BONUS.price; BONUS.price = wsb; touched = true; }
    }
    // The pump has no trade price today; honour one automatically if it ever gets one.
    if (PUMP) {
      var wsp = vMap[PUMP.variantId] != null ? vMap[PUMP.variantId] : pMap[PUMP.id];
      if (wsp != null && wsp > 0 && wsp < PUMP.price) {
        if (PUMP.rrp == null || PUMP.rrp < PUMP.price) PUMP.rrp = PUMP.price;
        PUMP.price = wsp; touched = true; initPump();
      }
    }
    if (!touched) return;
    if (DATA.isWholesale) {
      // Trade pricing replaces the retail mechanics — EXCEPT cutter heads, which keep
      // their quantity breaks for wholesale too (Melanie, 5 Aug 2026). SELLY offer 45922
      // is open to wholesale, so the head picker and its maths stay live on blade/clipper
      // pages. Everything else (pack %, tool ladder, bonus bait) is still retail-only.
      sellyWS = true;
      DATA.tierDuo = 0; DATA.tierWorks = 0; DATA.subPack = 0; DATA.subSingle = 0;
      TOOL_AMTS[0] = 0; TOOL_AMTS[1] = 0;
      if (!isHW) { DATA.hwTiers = [0, 0, 0]; HEAD_AMTS[0] = 0; HEAD_AMTS[1] = 0; HEAD_AMTS[2] = 0; }
      if (BONUS) BONUS.pct = 0;
      state.bonus = false; var bx = $('#mn-bonus'); if (bx) bx.hidden = true;
      if (!isHW) { state.nAddons = 0; state.slots = []; }
      var pr = $('#mn-price');
      if (pr && !document.getElementById('mn-wspill')) {
        var pill = document.createElement('div');
        pill.id = 'mn-wspill'; pill.textContent = 'Your Wholesale Price';
        pr.parentNode.insertBefore(pill, pr);
      }
    }
    renderSizes(); renderBundle(); renderSlots(); applyTradeMode(); update();
  }
  (function sellyWait() {
    var tries = 0;
    (function poll() {
      var hub = window.tdfEventHub;
      if (hub && hub.ListenToEvent) {
        hub.ListenToEvent('data_app2', function (n, cfg) { try { sellyApply(cfg); } catch (e) { /* never break the buy box */ } }, true);
      } else if (++tries < 240) setTimeout(poll, 250);
    })();
  })();

  // Wholesale buys tools at trade price and gets no retail tool ladder, so the
  // "2 tools save $5..." promise must not appear on their PDPs (Melanie, 5 Aug 2026).
  // Driven off the Liquid-rendered customer tag, so it is right on first paint —
  // it does not wait for SELLY prices to land.
  if (DATA.isWholesale) {
    $$('.mn-toolhint').forEach(function (el) { el.hidden = true; });
  }

  renderSizes();
  renderBundle();
  renderSlots();
  initBonus();
  initPump();
  applyTradeMode();
  update();
})();

/* Thumbs carousel arrows + fade indicators (PT port) */
(function(){
  var wraps = document.querySelectorAll('.ps-pdp .thumbs-wrap');
  wraps.forEach(function(w){
    var strip = w.querySelector('.thumbs');
    if(!strip) return;
    var prev = w.querySelector('.thumbs-nav.prev');
    var next = w.querySelector('.thumbs-nav.next');
    function update(){
      var maxScroll = strip.scrollWidth - strip.clientWidth - 1;
      if(prev) prev.hidden = strip.scrollLeft <= 4;
      if(next) next.hidden = strip.scrollLeft >= maxScroll;
    }
    function step(dir){
      var t = strip.querySelector('.thumb');
      var w1 = t ? (t.getBoundingClientRect().width + 8) : 120;
      strip.scrollBy({ left: dir * w1 * 3, behavior: 'smooth' });
    }
    if(prev) prev.addEventListener('click', function(){ step(-1); });
    if(next) next.addEventListener('click', function(){ step(1); });
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 50);
  });
})();

/* ===== collection & product videos (Shopify-hosted) ===== */
(function () {
  var grid = document.getElementById('mn-colvid-grid');
  if (!grid || !window.MN_VIDEO_MAP) return;
  var MAP = window.MN_VIDEO_MAP;
  var col = (grid.getAttribute('data-collection') || '').trim();
  var title = (grid.getAttribute('data-title') || '').toLowerCase();
  var type = null;
  if (/scrub/.test(title)) type = 'SCRUB';
  else if (/treatment/.test(title)) type = 'TREATMENT';
  else if (/spray/.test(title)) type = 'CCSPRAY';
  else if (/cologne|fragrance|perfume/.test(title)) type = 'COLOGNE';
  else if (/conditioner/.test(title)) type = 'CONDITIONER';
  else if (/shampoo/.test(title)) type = 'SHAMPOO';
  var colNice = col.charAt(0) + col.slice(1).toLowerCase();
  var cards = [];
  if (type && MAP[col + ' ' + type]) cards.push({ k: col + ' ' + type, cap: '<b>This product, up close</b> — what it does and how Mel uses it in the salon.' });
  if (MAP[col + ' COLLECTION']) cards.push({ k: col + ' COLLECTION', cap: '<b>The ' + colNice + ' collection</b> — the full range and who it\u2019s for.' });
  if (!cards.length) return;
  grid.innerHTML = cards.map(function (c) {
    var v = MAP[c.k];
    return '<div class="vidcard"><div class="vframe"><video controls preload="none" playsinline poster="' + v.poster + '"><source src="' + v.url + '" type="video/mp4"></video></div><p class="vcap">' + c.cap + '</p></div>';
  }).join('');
  document.getElementById('mn-colvids').hidden = false;
})();

/* ===== lite YouTube embeds ===== */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('.yt-lite');
  if (!b) return;
  var id = b.getAttribute('data-yt');
  var d = document.createElement('div');
  d.className = 'vframe';
  var f = document.createElement('iframe');
  f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
  f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
  f.setAttribute('allowfullscreen', '');
  f.title = b.getAttribute('aria-label') || 'Video';
  d.appendChild(f);
  b.parentNode.replaceChild(d, b);
});
